import SimpleButton from "../Input/SimpleButton";
import { ReverseSort } from "../Icons/Interface";
import { JobCardData } from "../../../DataModels/DataModels";
import {
	Menu,
	MenuBadge,
	MenuContainer,
	MenuItemElement,
	MenuAlignment,
	MenuDirection
} from "./Menu"; // Import the updated component

export type SortFunction<
	T extends { creationTimestamp: string; company: string }
> = (a: T, b: T) => number;

interface SortMenuProps<
	T extends { creationTimestamp: string; company: string }
> {
	onClick?: (func: SortFunction<T>) => void;
	onStatusChange?: (isOpen: boolean) => void;
	isTitle?: boolean;
	badgeClass?: string;
	menuClass?: string;
	itemClass?: string;
	alignment?: MenuAlignment;
	direction?: MenuDirection;
}

export const defaultSort: SortFunction<JobCardData> = (
	a: JobCardData,
	b: JobCardData
) => {
	//console.log("a:");console.log(a);console.log("b:");console.log(b);
	if (!a?.creationTimestamp || !b?.creationTimestamp) return 0;
	return (
		new Date(b.creationTimestamp).getTime() -
		new Date(a.creationTimestamp).getTime()
	);
};

export const SortMenu: React.FC<SortMenuProps<JobCardData>> = ({
	onClick = (func: SortFunction<JobCardData>) => {},
	onStatusChange = (isOpen: boolean) => {},
	isTitle = true,
	badgeClass = "w-36 bg-primary-background border-primary-active border text-primary rounded-full",
	menuClass = "bg-primary-background space-y-2 rounded-2xl border border-primary-active w-36 overflow-clip",
	itemClass = "text-primary-active hover:bg-primary-accent px-3 py-2 first:rounded-t-2xl last:rounded-b-2xl",
	alignment = "right",
	direction = "below"
}) => {
	const sortOptions = [
		{
			label: "Newest",
			func: defaultSort
		},
		{
			label: "Oldest",
			func: <T extends { creationTimestamp: string; company: string }>(
				a: T,
				b: T
			) => {
				if (!a?.creationTimestamp || !b?.creationTimestamp) {
					return 0; // or handle however you want
				}
				return (
					new Date(a.creationTimestamp).getTime() -
					new Date(b.creationTimestamp).getTime()
				);
			}
		},
		{
			label: "A-Z Company",
			func: <T extends { creationTimestamp: string; company: string }>(
				a: T,
				b: T
			) => (a?.company || "").localeCompare(b?.company || "")
		},
		{
			label: "Z-A Company",
			func: <T extends { creationTimestamp: string; company: string }>(
				a: T,
				b: T
			) => (b?.company || "").localeCompare(a?.company || "")
		}
		//TODO: Sort By Title?
	];

	return (
		<Menu onClickMenu={onClick} onStatus={onStatusChange}>
			<MenuBadge
				className="flex items-center"
				align={alignment}
				direction={direction}
			>
				{/* With Text */}
				{isTitle && (
					<SimpleButton className={badgeClass}>
						<div>{ReverseSort()}</div>
						<p>Sort By</p>
					</SimpleButton>
				)}

				{/* Icon Only */}
				{!isTitle && <div className={badgeClass}>{ReverseSort()}</div>}
			</MenuBadge>
			<MenuContainer className={menuClass}>
				{sortOptions.map((item: any, index: number) => (
					<MenuItemElement key={index} itemKey={item} className={itemClass}>
						<p>{item.label}</p>
					</MenuItemElement>
				))}
			</MenuContainer>
		</Menu>
	);
};
